module.exports = __webpack_public_path__ + "static/media/example-3.bd3e71e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/CCIWA/example-3.jpg
// module id = 220
// module chunks = 0